var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EDF9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 40.7812C48.5625 44.5264 45.5264 47.5625 41.7812 47.5625C38.0361 47.5625 35 44.5264 35 40.7812C35 37.0361 38.0361 34 41.7812 34C45.5264 34 48.5625 37.0361 48.5625 40.7812ZM40.9969 44.3719L46.0281 39.3406C46.199 39.1698 46.199 38.8928 46.0281 38.7219L45.4094 38.1032C45.2386 37.9323 44.9615 37.9323 44.7907 38.1032L40.6875 42.2064L38.7718 40.2907C38.601 40.1198 38.324 40.1198 38.1531 40.2907L37.5344 40.9094C37.3635 41.0802 37.3635 41.3572 37.5344 41.5281L40.3781 44.3718C40.549 44.5427 40.826 44.5427 40.9969 44.3719Z",
    fill: "#45982B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.602 14.7203L14.9142 14.8142V17.5369C14.602 17.7247 14.379 18.1002 14.379 18.4758C14.379 18.8983 14.5574 19.2269 14.8696 19.4147L14.1561 22.3252C14.0669 22.6538 14.2453 22.9824 14.5128 22.9824H16.3411C16.6087 22.9824 16.7871 22.6538 16.6979 22.3721L15.9844 19.4147C16.2965 19.2269 16.5195 18.8983 16.5195 18.4758C16.5195 18.1002 16.2965 17.7247 15.9844 17.5369V15.0958L18.3032 15.6592V18.4758C18.3032 21.8088 20.845 24.4846 24.0111 24.4846C27.1327 24.4846 29.6745 21.8088 29.6745 18.4758L29.7191 15.6592L33.3757 14.7203C34.1784 14.5325 34.1784 13.4528 33.3757 13.265L24.8584 11.1056C24.2787 10.9648 23.699 10.9648 23.1193 11.1056L14.602 13.265C13.7993 13.4528 13.7993 14.5325 14.602 14.7203ZM28.6042 25.6582L24.0111 30.4934L19.3735 25.6582C16.252 26.7378 14.0223 29.7423 14.0223 33.4039C14.0223 34.2959 14.6912 35 15.5385 35H32.4392C33.2865 35 34 34.2959 34 33.4039C34 29.7423 31.7258 26.7378 28.6042 25.6582Z",
    fill: "#307CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.bebcdc260c425f7f0c97f673178f2203.svg";
export { ForwardRef as ReactComponent };